import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=65a9e203&"
import script from "./spinner.ts?vue&type=script&lang=ts&"
export * from "./spinner.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports